module.exports = __webpack_public_path__ + "media/images/front/event_publish_lp/flow_03-21cf939f6b5d33861b5d26d72b80e403.png";